<template>
  <div
    class="tm-calendar-month-day"
    :class="{
      'tm-calendar-month-day--big': big,
      'tm-calendar-month-day--active': active,
      'tm-calendar-month-day--outdated': outdated,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  big?: boolean
  outdated?: boolean
  active?: boolean
}>()
</script>

<style lang="scss" scoped>
.tm-calendar-month-day {
  display: flex;
  min-width: 28px;
  height: 20px;
  font-weight: $semi-bold-font;
  font-size: $font-size-root;
  color: $emphasize;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  &--big {
    min-width: 30px;
    height: 30px;
    font-weight: $bold-font;
    font-size: $xm-font;
  }

  &--active {
    border-radius: 16px;
    color: $white;
    background: $primary;
  }

  &--outdated {
    color: $light;
  }
}
</style>
